export const UPDATE_PAGE_TITLE = 'COMMON.PAGE.UPDATE_PAGE_TITLE';